import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  validation,
  validationSuccess,
  validationFail,
} from "./validate.store";
import { validationSuccess as signinValidationSuccess } from "../signin/signin.store";
import { doCompanyFetch } from "../../company/company/company.actions";
import {
  TokenValidationResponse,
  MagicTokenValidationResponse,
} from "../../../model/auth-response";
import {
  doValidateTokenApiCall,
  doMagicTokenCheckApiCall,
} from "../../../services/auth/validate";
import { getActionErrorMessage } from "../../../shared/utilities";
import { ApiStateError } from "../../../model/error";

export const doTokenValidation = createAsyncThunk<
  TokenValidationResponse,
  { token: string }
>("validate-token: do", async (payload, { dispatch, rejectWithValue }) => {
  dispatch(validation());
  try {
    const response = await doValidateTokenApiCall(payload.token);

    dispatch(signinValidationSuccess(response.data));
    dispatch(validationSuccess(response.data));
    dispatch(doCompanyFetch());
    return response.data;
  } catch (err) {
    const error = err as ApiStateError;
    dispatch(validationFail());
    return rejectWithValue(
      getActionErrorMessage(error, "Error validating token")
    );
  }
});

export const doMagicTokenValidation = createAsyncThunk<
  MagicTokenValidationResponse,
  { magicToken: string }
>(
  "auth/validate/magic-token",
  async (payload, { dispatch, rejectWithValue }) => {
    dispatch(validation());
    try {
      const data = (await doMagicTokenCheckApiCall(payload.magicToken)).data;

      dispatch(signinValidationSuccess(data));
      dispatch(validationSuccess(data));
      return data;
    } catch (err) {
      const error = err as ApiStateError;
      dispatch(validationFail());
      return rejectWithValue(
        getActionErrorMessage(error, "Error validating magic token", {
          getObj: true,
        })
      );
    }
  }
);
